<!-- 标记知识点菜单，用于漏检图像库中的“图像种类”及配对题中的“标注类型” -->
<template>
    <el-form-item label="图像种类">
        <el-popover
            placement="bottom"
            width="260"
            trigger="click">
            <div class="mark-knowledge-tree">
                <el-tree
                    id="mark-know"
                    ref="tree"
                    :data="knowledgeData"
                    :props="defaultProps"
                    show-checkbox
                    node-key="id"
                    accordion
                    :default-expanded-keys="[0]"
                    @check-change="checkChange"
                    :getCheckedNodes="value"
                    :expand-on-click-node="false"
                    :render-content="renderContent">
                </el-tree>
            </div>
            <el-input slot="reference" v-model="knowledgeNames" placeholder="选择图像种类" collapse-tags readonly="readonly" clearable></el-input>

        </el-popover>
    </el-form-item>
</template>

<script>
    export default {
        components: {},

        props: {

        },

        data() {
            return {
                kpIds: [],
                value: '',
                knowledgeNames:'',
                knowledgeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'value'
                },
            }
        },

        mounted() {
            this.$store.dispatch('getMarkKnowledgeMenu').then(data => {
                this.knowledgeData = [{id: 0, value: this.$t('c.all'), children: data}]
            })

        },

        methods: {
            renderContent(h, {node, data, store}) {
                return (<span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;"><span><span>{node.label}</span></span></span>);
            },
            checkChange (val, checked, nodeChecked) {
                this.kpIds = this.$refs.tree.getCheckedKeys()
                this.$emit('knowledgeChange', this.kpIds);
                this.$emit('input', this.kpIds)

                let nodeNames=this.$refs.tree.getCheckedNodes();
                let newBox=[]

                nodeNames.forEach(item=>{
                    if(item.children){
                        item.children.forEach(item2=>{
                            newBox.push(item2.value)
                        })
                    }
                    newBox.push(item.value)
                })
                this.knowledgeNames = newBox
            },
        },
    }
</script>

<style  lang="scss">
    @import "../style/const";

    .mark-knowledge-tree {
        margin-right: -10px;
        margin-bottom: -5px;
        @include scrollbar(#ccc, 10px);
    }

    #mark-know {
        @include scrollbar(#ccc, 8px, 10px);
        max-height: 500px;
        overflow-y: auto;

        .el-tree-node .el-tree-node__children{
            overflow: auto;
        }
    }
</style>

